export const TOKEN_DATA_KEY = 'auth_data';
export const TOKEN_HEADER_KEY = 'Authorization';
export const TOKEN_KEY = 'auth-token';
export const REFRESHTOKEN_KEY = 'auth-refreshtoken';
export const USER_KEY = 'auth-user';
export const REMEMBER_KEY = 'auth-remember';
export const SSO_SUCCESS_KEY = 'sso-success';
export const SSO_ERROR_KEY = 'sso-error';
export const LAST_SESSION_KEY = 'lastSession';
export const STATUS_CODE_INVALID_SESSION = 333;
